import type { Staff } from "@/lib/authv2/store";
import { ACTION } from "@/lib/auth/actions";
import { hasPermission } from "@/lib/authv2/permissions";

/**
 * Trang "Điểm cơ sở" (QĐ 0246). Một quyền, nhiều vai (giám đốc, quản lý cụm,
 * trưởng cửa hàng, QC); phạm vi cơ sở do MÁY CHỦ cắt — trưởng cửa hàng chỉ nhận
 * về tiệm mình, màn không lọc thêm gì.
 */
export function canViewBranchScores(staff: Staff | null): boolean {
  if (!staff) return false;
  return hasPermission(ACTION.PerformanceBranchScoreRead);
}
